<template>
  <div>
    <form>
    <base-card v-if="!targetItem._id" id="typeSizes" >
        <base-question text="Essa categoria possui tamanhos?"/>

        <div class="d-flex">
            <div class="select-size mr_7" v-bind:class="{ selected: targetItem.sizes.length == 1}" @click.prevent="initSizes(1)">
                <div class="p_20 py_25">
                    <p class="mb_10"><i class="fal fa-wine-glass-alt"></i></p>
                    <p>Tamanho único</p>
                </div>
            </div>
            <div class="select-size ml_7" v-bind:class="{ selected: targetItem.sizes.length > 1}" @click.prevent="initSizes(2)">
                <div class="p_20 py_25">
                    <p class="mb_10">
                        <i class="fal fa-wine-glass-alt mr_5"></i>
                        <i class="fal fa-wine-glass-alt mr_5"></i>
                        <i class="fal fa-wine-glass-alt"></i>
                    </p>
                    <p>Vários tamanhos</p>
                </div>
            </div>
        </div>
        <div v-if="targetItem.sizes.length > 1" class="mt_30">
          <base-radio label="Tamanhos iguais nesta categoria" family="sizeslocation" class="mb_15" :value="targetItem.default_sizes" :option="true" @click="targetItem.default_sizes = true" />
          <base-radio label="Tamanhos diferentes por produto" family="sizeslocation" class="mb_25" :value="targetItem.default_sizes" :option="false" @click="targetItem.default_sizes = false"/>

          <base-message class="gold">
              <span v-if="!!targetItem.default_sizes">Tamanhos iguais para todos os produtos cadastrados nesta categoria / A definição dos tamanhos se aplicará de forma padrão a todos os produtos cadastrados.</span>
              <span v-else>Tamanhos específicos para cada produto cadastrado nesta categoria / A definição dos tamanhos será por produto, no cadastramento do mesmo.</span>
          </base-message>
        </div>
      </base-card>

      <!-- Tamanho único -->
      <div
        id="sizeSection"
        class="base-card-to-listen"
        v-if="targetItem.default_sizes && targetItem.sizes.length == 1"
      >
        <base-card v-if="targetItem.sizes.filter((i) => !i.delete).length > 0">
          <base-question text="Qual o tamanho?" class="mb_15"/>
          <div class="row half-cols">
            <div class="col-xs-6">
              <p class="text-title">Tamanho</p>
            </div>
            <div class="col-xs-3">
              <p class="text-title">Volume</p>
            </div>
            <div class="col-xs-3">
              <p v-if="!deleteMode.size" class="text-title">Medida</p>
            </div>
          </div>

          <div v-if="targetItem.sizes.length > 0">
            <diV v-for="(size) in targetItem.sizes" :key="size._id">
              <div v-if="!size.delete">
                <div class="row half-cols"> <!-- v-for para cada tamanho -->
                  <div class="col-xs-6">
                    <base-select placeholder="Embalagem" v-model="size.package" v-on:change="applyValue(size._id, 'package', size.package)" :valid="isValidField(size._id, 'package')">
                        <option
                          v-for="(packageType, i) in availablePackages"
                          :key="`package-${i}`"
                          :value="packageType"
                          :selected="size.package == packageType"
                        >{{PackageNames[packageType]}}</option>
                    </base-select>
                  </div>
                  <div class="col-xs-3">
                      <base-input v-model="size.amount" v-on:change="applyValue(size._id, 'amount', size.amount)" :valid="isValidField(size._id, 'amount')" />
                  </div>
                  <div class="col-xs-3">
                    <base-select v-model="size.unit" v-on:change="applyValue(size._id, 'unit', size.unit)" :valid="isValidField(size._id, 'unit')">
                        <option v-for="(unit, i) in availableUnits" :key="`unit-${i}`" :value="unit" :selected="size.unit == unit">{{unit}}</option>
                    </base-select>
                  </div>
              </div>
              </div>
            </diV>
          </div>
        </base-card>
      </div>
      <!-- fim Tamanho único -->

      <!-- Vários Tamanhos -->
      <div
        id="sizeSection"
        class="base-card-to-listen"
        v-if="targetItem.default_sizes && targetItem.sizes.length > 1"
      >
        <base-card v-if="targetItem.sizes.filter((i) => !i.delete).length > 0">
          <base-question text="Quais são os tamanhos?" class="mb_25"/>
          <div class="row half-cols mb_10">
            <div class="col-xs-5">
              <p class="text-title">Tamanho</p>
            </div>
            <div :class="!deleteMode.size ? 'col-xs-3' : 'col-xs-5'" >
              <p class="text-title">Volume</p>
            </div>
            <div :class="!deleteMode.size ? 'col-xs-4' : 'col-xs-2'">
              <p v-if="!deleteMode.size" class="text-title">Medida</p>
              <p v-else class="text-title">Excluir</p>
            </div>
          </div>

          <div v-if="targetItem.sizes.length > 0">
            <diV v-for="(size) in targetItem.sizes" :key="size._id">
              <div v-if="!size.delete">
                <div class="row half-cols"> <!-- v-for para cada tamanho -->
                  <div class="col-xs-5">
                    <base-select placeholder="Embalagem" v-model="size.package" v-on:change="applyValue(size._id, 'package', size.package)" :valid="isValidField(size._id, 'package')" class="mb_0">
                        <option
                          v-for="(packageType, i) in availablePackages"
                          :key="`package-${i}`"
                          :value="packageType"
                          :selected="size.package == packageType"
                        >{{PackageNames[packageType]}}</option>
                    </base-select>
                  </div>
                  <div class="pl_0" :class="!deleteMode.size ? 'col-xs-3' : 'col-xs-5'">
                      <base-input v-model="size.amount" v-on:change="applyValue(size._id, 'amount', size.amount)" :valid="isValidField(size._id, 'amount')" class="mb_0" />
                  </div>
                  <div v-if="!deleteMode.size" class="col-xs-4">
                    <base-select v-model="size.unit" v-on:change="applyValue(size._id, 'unit', size.unit)" :valid="isValidField(size._id, 'unit')" class="mb_0">
                        <option v-for="(unit, i) in availableUnits" :key="`unit-${i}`" :value="unit" :selected="size.unit == unit">{{unit}}</option>
                    </base-select>
                  </div>
                  <div v-else class="col-xs-2">
                    <base-button design="four"  class="w-100 mt_10 big icon" @click.prevent="deleteItem(size._id)">
                        <i class="fal fa-trash-alt"></i>
                    </base-button>
                  </div>
              </div>
              </div>
            </diV>
          </div>

          <div class="row mt_15">
            <div :class="!deleteMode.size && targetItem.sizes.length > 2 ? 'col-xs-6 pr_7' : 'col-xs-12'">
              <base-button v-if="targetItem.sizes.length > 1 && !deleteMode.size" :text="StringLanguage.add" design="two" @click.prevent="addSize()" class="w-100" />
            </div>
            <div :class="targetItem.sizes.length > 2 && !deleteMode.size ? 'col-xs-6 pl_7' : deleteMode.size ? 'col-xs-12' : ''">
              <base-button v-if="targetItem.sizes.length > 2 || deleteMode.size" :text="deleteMode.size ? StringLanguage.back : StringLanguage.remove" design="four" @click.prevent="deleteMode.size = !deleteMode.size" class="w-100" />
            </div>
          </div>
        </base-card>
      </div>
      <!-- fim Vários Tamanhos -->

      <!-- Extra -->
        <sized-list
          id="extrasSection"
          v-if="targetItem.default_sizes && targetItem.sizes.length > 0"
          title="Esta categoria possui extras?"
          elementPlaceholder="Nome do extra"
          addButtonText="Adicionar extra"
          :deleteMode="deleteMode.extra"
          :sizes="targetItem.sizes"
          :elements="targetItem.extra_ingredients.filter(e => !e.delete)"
          @deleteMode="(activated) => deleteMode.extra = activated"
          @removeElement="(e) => deleteItem(e._id, false)"
          @addNewItem="() => { deleteMode.extra = false, addExtraIngredient() }"
        ></sized-list>
      <!-- fim Ingrediente Extra -->

      <!-- Disponibilidade -->
      <base-availability
        name="da categoria"
        :availability="targetItem.availability"
        @updateAvailability="updateAvailability"
      ></base-availability>
      <!-- fim Disponibilidade -->
    </form>
  </div>
</template>
<script>
import Builder from "easyjs/lib/Schema/Components/Builder";
import Vue from "vue";
import { Money } from "v-money";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
import BaseTabs from "@/components/Tabs";
import BaseAdd from "@/components/Add";
import BaseMessage from "@/components/Message";
import BaseRadio from "@/components/Radio";
import BaseQuestion from "@/components/Question";
import BaseSelect from "@/components/Select";

import SizedList from '@/containers/Catalog/SizedList';
import BaseAvailability from "@/containers/Availability";
import StringTemplate from "easyjs/lib/Tools/StringTemplate";
import { PackageType, PackageNames } from "easyjs/lib/Schema/Components/PackageType";
import { VolumeUnit } from "easyjs/lib/Schema/Components/Unit";

export default {
  props: {
    setDeleteMode: { type: Function }
  },
  data() {
    return {
      StringTemplate,
      PackageNames,
      targetItem: Builder.factory("Category"),
      availablePackages: [
        PackageType.COPO,
        PackageType.GALAO,
        PackageType.GARRAFA,
        PackageType.JARRA,
        PackageType.LATA,
        PackageType.LONGNECK,
        PackageType.OTHER
      ],
      availableUnits: [
        VolumeUnit.mL,
        VolumeUnit.L
      ],
      errors: { main: [] },
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },
      deleteMode: {
        size: false,
        extra: false
      }
    };
  },
  components: {
    BaseCard,
    BaseInput,
    BaseButton,
    BaseTabs,
    BaseAdd,
    BaseMessage,
    BaseRadio,
    BaseQuestion,
    SizedList,
    BaseSelect,
    BaseAvailability,
  },
  watch: {
      targetItem: {
          deep: true,
          handler(newV) {
              this.$emit('updateModel', this.targetItem);
          }
      }
  },
  updated() {
    this.setDeleteMode('drink', this.deleteMode);
  },
  methods: {
    updateAvailability(newAvailability) {
      Vue.set(this.targetItem, "availability", newAvailability);
    },
    initSizes(numOfSize) {
      if(!this.targetItem) {
        return;
      }

      let sizeArray = [];
      for(var x = 0; x < numOfSize; x++) {
        let size = Builder.factory('Size');
        size.new = true;
        size._id = Builder.generateRandomId("_");
        size.parent = this.targetItem._id;
        if(numOfSize == 1){
            size.name = 'Tamanho único';
        }
        sizeArray.push(size);
      }

      Vue.set(this.targetItem, 'sizes', sizeArray);

      if(numOfSize == 1) {
        Vue.set(this.targetItem, 'default_sizes', true);
      }
      Vue.nextTick(() => {
        this.$emit("onScrollTo", "#typeSizes");
      })
    },
    cleanModel() {
      for (let key of Object.keys(this.deleteMode)) {
        this.deleteMode[key] = false;
      }
    },
    applyValue(_id, key, value) {
      this.targetItem.getItemsByParam("_id", _id).forEach((i) => {
        Vue.set(i, key, value);
        if(i.type == 'size') {
          Vue.set(i, "name", `${PackageNames[i.package]} (${i.amount} ${i.unit})`);
        }
      });
    },
    addNewItem(type, target, node) {
      let item = (node || this.targetItem).getItemsByParam("_id", target)[0];
      let newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId("_");
      newItem.parent = item._id;
      item.addItems(newItem);
      return newItem;
    },
    addSize() {
      this.addNewItem("Size", this.targetItem._id);
      this.updateItems();
      this.updateExtras();
      if(this.targetItem.new == false && this.targetItem.items.forEach((position) => { position.items.length > 0})) {
        alert("Tamanho adicionado com sucesso, configure os valores em cada produto.");
      }
    },
    addExtraIngredient() {
      if (this.targetItem.mode == 'simple' || this.targetItem.sizes.filter(i => !i.delete).length > 0) {
        this.addNewItem("Extraingredient", this.targetItem._id);
        this.updateExtras();
      } else {
        alert("Você precisa cadastrar algum tamanho antes.");
      }
    },
    setModel(item, parent) {
      this.cleanModel();
      this.targetItem = item || Builder.factory("Category");
      this.targetItem.parent = null;
      if(this.targetItem.sizes.length == 0) {
        let defaultSize = Builder.factory("Size");
        defaultSize._id = Builder.generateRandomId("_");
        defaultSize.name = "Tamanho Único";
        this.targetItem.addItems(defaultSize);
      }
    },
    changePizzaTab(tab) {
      this.deleteMode.size = false;
      this.pizzaTab = tab;
    },
    deleteItem(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
            this.targetItem.getItemsByParam("_id", id).forEach(i => Vue.set(i, 'delete', true))
            //Remove todos os tamanhos que foram excluídos
            let catalog = Builder.factory('Catalog');
            catalog.addItems(this.targetItem);
            Builder.executeOnSchema(catalog, (item) => {
              if(item.sizes.length > 0) {
                Vue.set(item, 'sizes', item.sizes.filter(s => !s.delete))
              }
            });
        }

        if(showConfirm) {
          confirm(StringLanguage.confirmDelete, res => res && deleteFn());
        } else {
          deleteFn();
        }

      } else {
        this.targetItem.delete = true;
        this.$emit("saveItem", this.targetItem);
      }
    },
    getItem() {
      return this.targetItem;
    },
    updateItems() {
      this.targetItem.items.forEach(e => {
        let itemSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return itemSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    },
    updateExtras() {
      this.targetItem.extra_ingredients.forEach(e => {
        let extraSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return extraSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    },
    isValidField(_id, field) {
      return !this.errors[_id] || this.errors[_id].indexOf(field) == -1;
    },
    highlightErrorFields() {

      this.errors = { main: [] };

      if(!this.targetItem.name) {
        this.errors.main = [...(this.errors.main || []), 'name'];
      }

      if(this.targetItem.default_sizes) {
        if(this.targetItem.sizes.length > 0) {
          this.targetItem.sizes.forEach((s) => {
            this.errors[s._id] = [
              !s.unit && 'unit',
              !s.package && 'package',
              !s.amount && 'amount'
            ].filter(s => !!s);
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.row.half-cols > *:not(:last-child) {
  padding-right: 7.5px;
}
.row.half-cols > *:not(:first-child) {
  padding-left: 7.5px;
}
.text-title {
  text-transform: uppercase;
  color: var(--label-primary);
  font-weight: bold;
  font-size: 10px;
  width: 100%;
  text-align: center;
}
.text-title.double:not(.left) {
  text-align: left !important;
  margin-bottom: 5px;
}
.text-title.left {
  text-align: left !important;
  min-width: 120px;
  max-width: 120px;
  padding-left: 10px;
}
.card-header {
  position: relative;
}

.card-header .close-button,
.card-header .open-button {
  cursor: pointer;
  position: absolute;
  top: -4px;
  right: 5px;
}

.card-header span.open-button {
  top: 4px;
}

.select-size {
  background: var(--box-up);
  width: 100%;
  color: var(--label-primary);
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  border-radius: 5px;
  border: 1px solid transparent;
  cursor: pointer;
}

.select-size i {
  color: var(--icon-inactive);
  font-size: 1.7em;
}

.select-size:last-child i:nth-child(1) {
  font-size: 1em;
}

.select-size:last-child i:nth-child(2) {
  font-size: 1.3em;
}

.select-size:last-child i:nth-child(3) {
  font-size: 1.6em;
}

.select-size.selected,
.select-size.selected i {
  color: var(--default);
}

.eae-title{
    font-size: 1.4em;
    padding: 16px 0 15px 0;
    text-align: center;
    width: 100%;
    background: #eee;
    margin-bottom: 25px;
    color: #999;
}
</style>
